import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.638 3.577a.75.75 0 0 0-1.06 1.06l1.275 1.277a8.03 8.03 0 0 0-2.438 3.545.75.75 0 0 0 0 .487A8.02 8.02 0 0 0 13.5 14.56l1.863 1.863a.75.75 0 0 0 1.06-1.06zm7.723 9.844-1.914-1.913q-.213.052-.44.053H9.99A1.858 1.858 0 0 1 8.19 9.249l-2.27-2.27a6.53 6.53 0 0 0-1.996 2.723 6.52 6.52 0 0 0 8.438 3.72m3.716-3.719a6.5 6.5 0 0 1-1.257 2.03l1.061 1.06a8 8 0 0 0 1.704-2.846.75.75 0 0 0 0-.487A8.02 8.02 0 0 0 7.522 4.433l1.23 1.23q.605-.12 1.248-.12a6.52 6.52 0 0 1 6.077 4.16",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }